import React from 'react';
import cn from 'classnames';
import { useEditorContainerSize } from '@wix/da-editor-tiptap/pkg/components/Editor/Context';
import { Props } from '../MonoView';
import EditorDeviationLink from '../_partials/DeviationLink';
import { useFreeformSquareSizing } from '../helpers';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Timestamp from '../../../Timestamp';

import s from './Poll.scss';

const MAX_QUESTION_LENGTH = 55;

const PollMonoView: React.FC<Props> = props => {
  const containerSize = useEditorContainerSize();
  const { deviation, extOptions, width: propsWidth, link } = props;
  const { width, height } = useFreeformSquareSizing(
    propsWidth,
    extOptions,
    containerSize
  );
  const { poll } = deviation;

  const questionTruncated =
    poll?.question && poll.question.length > MAX_QUESTION_LENGTH
      ? `${poll.question.slice(0, MAX_QUESTION_LENGTH)}...`
      : poll?.question;

  return (
    <div className={cn(s['root'])} style={{ width, height }}>
      <EditorDeviationLink link={link} deviation={deviation}>
        <Section>
          <Heading className={s['question']}>{questionTruncated}</Heading>
          <div className={s['info']}>
            <span className={s['date']}>
              <Timestamp timestamp={poll?.ts} />
            </span>
            &nbsp; | &nbsp;
            <span className={s['vote-count']}>{poll?.votes} votes</span>
          </div>
        </Section>
      </EditorDeviationLink>
    </div>
  );
};
PollMonoView.displayName = 'PollMonoView';

export default PollMonoView;
